import { SHOW_SNACKBAR, HIDE_SNACKBAR } from './actionTypes';

const showSnackbar = (message, variant) => ({
  type: SHOW_SNACKBAR,
  message,
  variant,
});

const hideSnackbar = () => ({
  type: HIDE_SNACKBAR,
});

export {
  showSnackbar,
  hideSnackbar,
};



// WEBPACK FOOTER //
// ./src/actions/snackbar/index.js